import ExportsActions from 'pages/Exports/components/ExportsActions'
import { useMutation } from '@apollo/client'
import { POSTAL_LIST_EXPORT } from 'graphql/exports/queries'
import { hasNoError } from 'globals/graphql'
import { useTranslation } from 'react-i18next'
import { ExportDescription } from './styles'

interface IProps {
  onShowExportConfirmation: () => void
}

const PostalListExport = (props: IProps) => {
  const { onShowExportConfirmation } = props
  const { t } = useTranslation()
  const [postalListExport] = useMutation(POSTAL_LIST_EXPORT)

  const onExport = () =>
    postalListExport().then(hasNoError(() => onShowExportConfirmation()))


  return (
    <div>
      <ExportsActions
        noRangeDatePicker
        onExport={onExport}
      />
      <ExportDescription>
        <span>{t('exports.postal-list-export.description')}</span>
      </ExportDescription>
    </div>
  )
}

export default PostalListExport
